module.exports = __webpack_public_path__ + "static/media/400127_01.186128b0.png";